class FrameModifications extends HTMLElement {
  connectedCallback() {
    this.productRenderer = this.closest('[data-product-wrapper]');
    this.gallery = this.productRenderer?.querySelector('[data-product-gallery]');
    this.form = this.closest('[data-product-form]');
    this.variantSelection = this.form.querySelector('variant-selection');
    this.framingContainer = this.querySelector('[js-framing]');
    this.framingOptions = this.querySelectorAll('[js-frame-options]');
    this.moneyFormat = this.dataset.moneyFormat;
    this.sizeIndex = Number(this.getAttribute('data-size-index')) || 0;
    this.materialIndex =  Number(this.getAttribute('data-material-index')) || 1;

    this.selectedMaterial = this.getAttribute('data-selected-material') || '';
    this.selectedSize = this.getAttribute('data-selected-size') || '';
    this.selectedHandle = this.selectedMaterial.toLowerCase().replace(/ /g, '-');
    this.options = this.querySelectorAll('[js-finish-options]');
    this.selectedFinish = [...this.options].find((option) => option.checked);
    this.selectedFramingOption = [...this.framingOptions].find((option) => option.checked);
    this.colorLabel = this.querySelector('[js-color]');
    this.addon = this.querySelector('[js-addon]');

    this.handleOptionChange();
    this.handleAddToCart();

    this.variantSelection.addEventListener('variant-change', (event) => {
        this.updateFromVariant(event.detail.variant);
    });

    this.variantSelection.getVariant().then((variant) => {
      if (variant) {
        this.updateFromVariant(variant);
      }
    });
  }

  updateFromVariant(variant) {
    this.selectedMaterial = variant.options[this.materialIndex];
    this.selectedSize = variant.options[this.sizeIndex];
    this.selectedHandle = this.selectedMaterial
        .toLowerCase()
        .replace(/ /g, '-');

    this.gallery.dataset.type = this.selectedHandle;
    this.handleVariantChange(
      this.selectedMaterial
    );

    const isA5Canvas = this.selectedSize === 'A5' && this.selectedHandle.includes('canvas');

    if (isA5Canvas) {
      this.classList.add('frames-hidden');

      const unframed =   [...this.options].find(
          (option) =>
            option.value === 'Unframed'
        );

      if (unframed) {
        unframed.checked = true;
        this.selectedFinish =     unframed;
        this.addon.value = '';
      }

    } else {
      this.classList.remove(
        'frames-hidden'
      );
    }

    this.updateFramingOptions(
      this.selectedSize === 'A0' ||
      this.selectedSize === '90x90cm'
    );

    this.handleFramePrices(this.selectedSize);
  }

  updateFramingOptions(hideBasic) {
    this.framingOptions.forEach(
      (framing, index) => {
        const isProfessional = framing.value.includes('Professional');

        if (hideBasic) {
          if (isProfessional) {
            framing.checked = true;
            this.selectedFramingOption = framing;
            framing.parentNode.classList.remove('frames-hidden');
          } else {
            framing.checked = false;
            framing.parentNode.classList.add('frames-hidden');
          }
        } else {
          framing.parentNode.classList.remove('frames-hidden' );
          framing.checked = index === 0;

          if (index === 0) {
            this.selectedFramingOption = framing;
          }
        }
      }
    );
  }

  handleFramePrices(size) {
    const priceEl = this.querySelector('[js-price]');

    if (!this.selectedFinish || !priceEl) { return };

    // UNFRAMED
    if (this.selectedFinish.value === 'Unframed') {
      priceEl.textContent =  Shopify.formatMoney(0, this.moneyFormat);
     this.addon.value = '';
      return;
    }

    const frameHandle = this.selectedFinish.value.toLowerCase().replace(/\s+/g, '-');
    const isCanvas = this.selectedMaterial.toLowerCase().includes('canvas');
    const productType = isCanvas  ? 'canvas' : 'poster';
    const productScript = [
        ...this.querySelectorAll(
          '[js-frame-products]'
        )
    ].find((script) => {
      const data = JSON.parse(script.textContent);

      return data[
        `${productType}--${frameHandle}`
      ];
    });

    if (!productScript) return;

    const productData = JSON.parse(productScript.textContent);
    const frameProduct = productData[`${productType}--${frameHandle}`];

    if (!frameProduct) return;

    const selectedFrameValue = this.selectedFramingOption
        ?.value
        ?.trim();

    const variant =
      frameProduct.variants.find((variant) => {
        const variantOptions = variant.options.map((option) => option.trim() );
        const matchesSize = variantOptions.includes(size);

        if (isCanvas) {
          return matchesSize;
        }

        const matchesFrameOption = selectedFrameValue ? variantOptions.includes(selectedFrameValue) : true;

        return (
          matchesSize &&
          matchesFrameOption
        );
      });

    if (!variant) return;

    const price = Number(variant.price);

    priceEl.textContent = Shopify.formatMoney(price, this.moneyFormat);
    this.addon.value = variant.id;
  }

  handleVariantChange(materialOption) {

    if (!materialOption) return;

    this.getFrameImage(
      materialOption
    );

    this.handleFramingOptions();
  }

  handleOptionChange() {

    this.options.forEach(
      (option) => {

        option.addEventListener(
          'change',
          () => {

            if (!option.checked) return;

            this.selectedFinish =
              option;

            this.colorLabel.textContent =
              option.value;

            this.handleFramingOptions();

            this.handleFramePrices(
              this.selectedSize
            );

            this.getFrameImage(
              this.selectedMaterial
            );
          }
        );
      }
    );

    this.framingOptions.forEach(
      (option) => {

        option.addEventListener(
          'change',
          () => {

            if (!option.checked) return;

            this.selectedFramingOption =
              option;

            this.handleFramePrices(
              this.selectedSize
            );
          }
        );
      }
    );
  }

  handleFramingOptions() {

    const hideFraming =
      this.selectedFinish.value ===
      'Unframed' ||
      this.selectedMaterial
        .toLowerCase()
        .includes('canvas');

    this.framingContainer.classList.toggle(
      'frames-hidden',
      hideFraming
    );
  }

  updateFrameImage(url) {

    const attachedImage =
      this.gallery?.querySelector(
        '.product-gallery--media[data-gallery-selected="true"]'
      );

    const frameImage =
      attachedImage?.querySelector(
        '.frame-image'
      );

    if (!frameImage) return;

    frameImage.style.backgroundImage =
      `url(${url})`;
  }

  getFrameImage(materialOption) {

    const paperSizes = [
      'A5',
      'A4',
      'A3',
      'A2',
      'A1',
      'A0'
    ];

    const selectedMaterialOption =
      this.selectedFinish;

    if (
      !selectedMaterialOption ||
      !materialOption
    ) return;

    let selectedImage = '';
    let sizeRatio = 'paper';
    let orientation = 'portrait';

    if (paperSizes.includes(this.selectedSize)) {
      if (this.gallery.dataset.orientation ?.includes('landscape')) {
        orientation = 'landscape';
      }
    } else {
      sizeRatio = 'square';
      orientation = 'square';
    }

    this.gallery.dataset.orientation = orientation;

    const isCanvas = materialOption.toLowerCase().includes('canvas');

    if (isCanvas) {
      if (this.selectedSize !== 'A5') {
        selectedImage =
          sizeRatio === 'paper'
            ? selectedMaterialOption.getAttribute(
              'data-canvas-image'
            )
            : selectedMaterialOption.getAttribute(
              'data-square-canvas-image'
            );
      }
    } else {
      selectedImage =
        sizeRatio === 'paper'
          ? selectedMaterialOption.getAttribute(
            'data-frame-image'
          )
          : selectedMaterialOption.getAttribute(
            'data-square-frame-image'
          );
    }

    this.updateFrameImage(
      selectedImage
    );
  }

  handleAddToCart() {
    this.form.addEventListener('submit', async (event) => {
        const addonVariantId =
          this.addon?.value;

        // Let Empire handle normal ATC
        if (!addonVariantId) { return; }

        event.preventDefault();
        event.stopImmediatePropagation();

        const formData = new FormData(this.form);

        const quantity =
          Number(
            formData.get('quantity')
          ) || 1;

        const mainVariantId =
          formData.get('id');

        const productTitle =
          formData.get('product-title');

        const properties = {};

        for (
          const [key, value]
          of formData.entries()
        ) {

          if (
            key.startsWith(
              'properties['
            )
          ) {

            const cleanKey =
              key
                .replace(
                  'properties[',
                  ''
                )
                .replace(
                  ']',
                  ''
                );

            properties[
              cleanKey
            ] = value;
          }
        }

        const groupKey = `frame-${Date.now()}`;

        properties.Frame_included = 'Yes';
        properties._groupKey = groupKey;

        const items = [
          {
            id: Number(
              mainVariantId
            ),
            quantity,
            properties
          },
          {
            id: Number(
              addonVariantId
            ),
            quantity,
            properties: {
              FrameFor: productTitle,
              _groupKey: groupKey
            }
          }
        ];

        try {

          const response =
            await fetch(`${window.Theme.routes.cart_add_url}.js`, {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json'
              },
              body: JSON.stringify({
                items
              })
            });

          if (!response.ok) {
            throw new Error(
              'Cart add failed'
            );
          }

          window.location.href =
            window.Theme.routes.cart_url;

        } catch (error) {

          console.error(error);
        }
      },
      true
    );
  }
}

customElements.define(
  'frame-modifications',
  FrameModifications
);